import { CSSInterpolation } from "@emotion/serialize";

type ThemeType = {
  colors: {
    [key: string]: string;
  };
  components: {
    [key: string]: {
      [key: string]: string | CSSInterpolation;
    };
  };
};

export const colors = {
  background: "#FFFFFF",
  text: "#404040",
  error: "#e11931",

  red: "#E11931",
  green: "#3eac58",
};

const theme: ThemeType = {
  colors,
  components: {
    input: {
      fontFamily: "Roboto, sans-serif",
      fontWeight: 400,
      fontSize: "1rem",
      height: "48px",
      color: "#404040",
      padding: "16px 8px 0px",
      gap: "8px",
      border: "none",
      borderRadius: "8px",
      background: "#F4F4F4",
      wrapper: {
        position: "relative",
        display: "flex",
        flexDirection: "column",
      },
      label: {
        fontFamily: "Roboto, sans-serif",
        position: "absolute",
        color: "#404040",
        fontWeight: 400,
        lineHeight: "24px",
        left: "8px",
        bottom: "2px",
      },
      helper: {
        fontFamily: "Roboto, sans-serif",
        fontSize: "12px",
        fontWeight: 400,
        lineHeight: "16px",
        letterSpacing: "0.24px",
        textAlign: "left",
        color: "#676767",
        marginTop: "4px",
        padding: "0 8px",
      },
      error: {
        fontFamily: "Roboto, sans-serif",
        fontSize: "12px",
        fontWeight: 400,
        lineHeight: "16px",
        letterSpacing: "0.24px",
        textAlign: "left",
        color: colors.error,
        marginTop: "4px",
        padding: "0 8px",
      },
    },
  },
};

export default theme;
